import React from "react";
import { Grid } from "@material-ui/core";
import Moment from 'moment';
import { IconsGrid } from "../../../../IconsGrid/.mixins";

import { css } from "./styles";

export function CardProduto({ produto, id_produto, handleClickIconDownload, handleClickIconView, handleClickIconPrint, pdf_link }) {
    const styles = css();

    return (
        <Grid container className={styles.card_produto}>
            <Grid xs={6.5} className={styles.ids}>
                <strong>
                    Número da ficha: {produto.nr_ficha_fornec}
                </strong>
                <br />
                ID do produto: {produto.id}
                <br />
                Atualização: {Moment(produto.dt_atlz).format('DD/MM/YYYY')}
            </Grid>

            <Grid xs={5} className={styles.icons}>
                <IconsGrid
                    isInsideModal
                    handleClickIconDownload={handleClickIconDownload}
                    handleClickIconView={handleClickIconView}
                    handleClickIconPrint={handleClickIconPrint}
                    pdf_link={pdf_link} />
            </Grid>
        </Grid>
    );
}
